'use strict';

/**
 * Default setting index view
 *
 * @category   View
 * @module     dashboard
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');
var template = require('modules/helpdesk/templates/layout/index.hbs');

var IndexLayout = LayoutView.extend({
    template: template,

    className: 'settings settings-helpdesk',
});

module.exports = IndexLayout;